export const generate_element_fields = () => ({
    backgroundColor: '#F4F8FF',
    tooltip: {
        show:false,
    },
    legend: {
        show: false,
    },
    grid: {
        left: '-8%',
        right: '4%',
        bottom: '3%',
        containLabel: true
    },
    xAxis: [
        {
            type: 'category',
            boundaryGap: false,
            axisLine: {show: true},
            axisLabel: {show: false},
            axisTick: {show: false},
            splitLine: {show: false},
        }
    ],
    yAxis: [
        {
            type: 'value',
            show:false,
            minorTick: {
                show:false
            },
            minorSplitLine: {
                show:false
            },
            splitLine: {
                show: false
            }
        }
    ],
    series: [
        {
            name: '数据',
            type: 'line',
            stack: '总量',
            color: '#7FBDF2',
            areaStyle: {
                color: '#7FBDF2',
                opacity: 0.6
            },
            data: []
        },
    ]
});
